import t, { useRef as n, useEffect as e, useState as r } from "react";
export default function (i) {
  var o,
      u,
      a,
      l = i.children,
      c = i.autoplay,
      f = void 0 === c || c,
      s = i.transitionDuration,
      d = void 0 === s ? 1e3 : s,
      m = i.transitionFunction,
      v = void 0 === m ? "ease" : m,
      y = i.autoplayDuration,
      h = void 0 === y ? 5e3 : y,
      p = i.renderControls,
      w = void 0 === p ? function () {} : p,
      E = r(0),
      T = E[0],
      g = E[1],
      D = r(0),
      k = D[0],
      x = D[1],
      C = r(0),
      F = C[0],
      I = C[1],
      X = l.length,
      b = function b(t) {
    k === T && (I(t === X ? 0 : -1 === t ? X - 1 : t), x(t));
  },
      P = function P() {
    return b((T + 1) % (X + 1));
  };

  return o = function o() {
    P();
  }, u = f ? h : null, a = n(), e(function () {
    a.current = o;
  }, [o]), e(function () {
    if (null !== u) {
      var t = setInterval(function () {
        return a && a.current && a.current();
      }, u);
      return function () {
        return clearInterval(t);
      };
    }

    return function () {};
  }, [u]), e(function () {
    var t = setTimeout(function () {
      g(F), x(F);
    }, d);
    return function () {
      return clearTimeout(t);
    };
  }, [d, F]), t.createElement("div", {
    style: {
      position: "relative",
      width: "100%",
      overflow: "hidden"
    }
  }, t.createElement("div", {
    style: {
      display: "flex",
      width: 100 * (X + 2) + "%",
      transitionProperty: "transform",
      willChange: "transform",
      transitionTimingFunction: v,
      transitionDuration: k !== T ? d + "ms" : "0ms",
      transform: "translateX(-" + (k + 1) / (X + 2) * 100 + "%)",
      WebkitTransform: "translateX(-" + (k + 1) / (X + 2) * 100 + "%)"
    }
  }, t.createElement("div", {
    style: {
      width: "100%"
    }
  }, l[X - 1]), l.map(function (n, e) {
    return t.createElement("div", {
      style: {
        width: "100%"
      },
      key: e
    }, n);
  }), t.createElement("div", {
    style: {
      width: "100%"
    }
  }, l[0])), w(P, function () {
    return b((T - 1) % X);
  }, b, F, X));
}